import { text } from "@fortawesome/fontawesome-svg-core";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { EDPNContext } from "../../pages/edpn/EDPNContext";
import { EDPNAnswer, EDPNAnswerObject, EDPNQuestion, TherapistSmallObject } from "../../utils/Definitions";
import { GlobalContext } from "../../utils/GlobalContext";
import { EDPNNarritiveSentance } from "./EDPNNarritiveSentence";
import { EDPNRequiredAsterisk } from "./EDPNRequiredAsterisk";

interface Props {
    EDPNQuestion: EDPNQuestion,
    setAnswerObject: React.Dispatch<React.SetStateAction<EDPNAnswerObject | null>>,
    answerObject: EDPNAnswerObject | null,
    EDPNQuestions: EDPNQuestion[],
    Therapists: TherapistSmallObject[] | null,
    requiredQuestionsAsterisk: EDPNQuestion[],
}

export const EDPNQuestionTypeTextParticipate: React.FC<Props> = (props) => {

    const [textValue, setTextValue] = useState<string>("");

    const edpnContext = useContext(EDPNContext);
    const globalContext = useContext(GlobalContext);

    const [disabled, setDisabled] = useState<boolean>(false);

    useEffect(() => {
        if (props.answerObject && props.answerObject.answers) {
            var enabled = props.answerObject?.answers?.find(x => x.questionId == 246 || x.questionId == 249)?.boolValue;

            if (enabled) {
                if (disabled) {
                    setDisabled(false);
                }
            }
            else {
                if (!disabled) {
                    setTextValue('');

                    setDisabled(true);
                }
            }
        }
    }, [props.answerObject]);

    useEffect(() => {
        if (edpnContext.selectedEditAnswer && props.answerObject && props.answerObject.answers && props.EDPNQuestion) {
            var tempanswer = props.answerObject.answers.find(x => x.questionId == props.EDPNQuestion.questionId);

            if (tempanswer && tempanswer.textValue) {
                //autopopulate text value
                setTextValue(tempanswer.textValue);
            }
        }
       
    }, [props.answerObject, props.answerObject?.answers, props.EDPNQuestion]);

    useEffect(() => {
        //autopopulate answer object
        if (props.answerObject && props.answerObject.answers) {
            var answer = props.answerObject.answers.find(x => x.questionId == props.EDPNQuestion.questionId);
            if (!answer) {

                var AutoPopulatedText = edpnContext.selectedEditAnswer?.answers?.find(x => x.questionId == props.EDPNQuestion.questionId)?.textValue;

                if (edpnContext.selectedEditAnswer == null) {
                    AutoPopulatedText = props.EDPNQuestion.defaultText;
                }

                //if answer doesn't already exist, create new
                var tempAnswer: EDPNAnswer = {
                    answerId: null,
                    questionId: props.EDPNQuestion.questionId,
                    multiIndex: null,
                    logId: null,
                    textValue: AutoPopulatedText ? AutoPopulatedText : null,
                    numberValue: null,
                    boolValue: null,
                    choiceValue: null,
                    log: null,
                    question: null
                };

                var tempAnswers = props.answerObject.answers;
                tempAnswers.push(tempAnswer);

                props.setAnswerObject({ ...props.answerObject, answers: tempAnswers });
            }
        }

    }, [edpnContext.selectedEditAnswer, props.answerObject]);

    function SaveToObject(input: string) {
        if (props.answerObject && props.answerObject.answers) {

            //if answer already exists, update
            var answer = props.answerObject.answers.find(x => x.questionId == props.EDPNQuestion.questionId);
            if (answer) {

                var tempAnswers = props.answerObject.answers;
                if (tempAnswers) {
                    tempAnswers.filter(x => x.questionId == props.EDPNQuestion.questionId).forEach(x => x.textValue = input);
                }

                props.setAnswerObject({ ...props.answerObject, answers: tempAnswers });
            }
            else {
                //if answer doesn't already exist, create new
                var tempAnswer: EDPNAnswer = {
                    answerId: null,
                    questionId: props.EDPNQuestion.questionId,
                    multiIndex: null,
                    logId: null,
                    textValue: input,
                    numberValue: null,
                    boolValue: null,
                    choiceValue: null,
                    log: null,
                    question: null
                };

                var tempAnswers = props.answerObject.answers;
                tempAnswers.push(tempAnswer);

                props.setAnswerObject({ ...props.answerObject, answers: tempAnswers});
            }
        }
    }

    function OpenExample() {
        if (props.EDPNQuestion.exampleText) {
            edpnContext.setExampleMessage(props.EDPNQuestion.exampleText);
            edpnContext.setExampleModalActive(true);
        }
    }

    if (props.EDPNQuestion.exampleText) {
        return (
            <>
                <div className={"w-full m-auto mt-4 grid grid-cols-12 " + (disabled ? "hidden" : "") + " col-span-" + (props.EDPNQuestion.colspan ? props.EDPNQuestion.colspan : '12')}>
                    <label className="font-bold col-span-11">
                        {props.EDPNQuestion.questionText}
                        <EDPNRequiredAsterisk key={'asterisk:' + (props.EDPNQuestion.questionId)} EDPNQuestion={props.EDPNQuestion} requiredQuestionsAsterisk={props.requiredQuestionsAsterisk} />
                    </label>
                    <div onClick={OpenExample} className="cursor-pointer ml-auto mb-1 col-span-1">
                        <FontAwesomeIcon className="w-8 h-8 mr-auto align-middle text-lacblue hover:text-lacblue-500" icon={solid('circle-info')} />
                    </div>
                    {/*<input  disabled={edpnContext.isViewOnly} onChange={(event) => SaveToObject(event.target.value)} defaultValue={textValue} autoComplete="off" type="text" className="outline-none h-[38px] border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue block w-full p-2.5 col-span-12" />*/}
                    <div id={"T_" + props.EDPNQuestion.questionId.toString()} className="grammar outline-none col-span-12 min-h-[35px] overflow-y-hidden border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue block w-full max-w-full p-2.5" contentEditable={!edpnContext.isViewOnly} onBlur={(event) => { SaveToObject(event.currentTarget.innerText); edpnContext.setAutosaveFlag(true); }} dangerouslySetInnerHTML={{ __html: textValue }} onCut={(event) => { if (!globalContext.CheckRoles('BCBA')) event.preventDefault(); }} onCopy={(event) => { if (!globalContext.CheckRoles('BCBA')) event.preventDefault(); }} onPaste={(event) => { if (!globalContext.CheckRoles('BCBA')) event.preventDefault();}}></div>
                </div>
                <div className={"w-full col-span-12 " + (props.EDPNQuestion.narrativeText ? '' : 'hidden')}>
                    {props.EDPNQuestion.narrativeText && props.answerObject && props.Therapists && <EDPNNarritiveSentance key={`narritive_${props.EDPNQuestion.questionId}`} Narritive={props.EDPNQuestion.narrativeText} EDPNAnswerObject={props.answerObject} Therapists={props.Therapists} EDPNQuestions={props.EDPNQuestions} answerObject={props.answerObject} setAnswerObject={props.setAnswerObject} />}
                </div>
            </>
            
        )
    }
    else {
        return (
            <>
                <div className={"w-full m-auto mt-4 " + (disabled ? "hidden" : "") + " col-span-" + (props.EDPNQuestion.colspan ? props.EDPNQuestion.colspan : '12')}>
                    <label className="block font-bold">
                        {props.EDPNQuestion.questionText}
                        <EDPNRequiredAsterisk key={'asterisk:' + (props.EDPNQuestion.questionId)} EDPNQuestion={props.EDPNQuestion} requiredQuestionsAsterisk={props.requiredQuestionsAsterisk} />
                    </label>
                    {/*<input  disabled={edpnContext.isViewOnly} onChange={(event) => SaveToObject(event.target.value)} defaultValue={textValue} autoComplete="off" type="text" className="outline-none h-[38px] border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue block w-full p-2.5" />*/}
                    <div id={"T_" + props.EDPNQuestion.questionId.toString()} className="grammar outline-none col-span-12 min-h-[35px] overflow-y-hidden border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue block w-full max-w-full p-2.5" contentEditable={!edpnContext.isViewOnly} onBlur={(event) => { SaveToObject(event.currentTarget.innerText); edpnContext.setAutosaveFlag(true); }} dangerouslySetInnerHTML={{ __html: textValue }} onCut={(event) => { if (!globalContext.CheckRoles('BCBA')) event.preventDefault(); }} onCopy={(event) => { if (!globalContext.CheckRoles('BCBA')) event.preventDefault(); }} onPaste={(event) => { if (!globalContext.CheckRoles('BCBA')) event.preventDefault();}}></div>
                </div>
                <div className={"w-full col-span-12 " + (props.EDPNQuestion.narrativeText ? '' : 'hidden')}>
                    {props.EDPNQuestion.narrativeText && props.answerObject && props.Therapists && <EDPNNarritiveSentance key={`narritive_${props.EDPNQuestion.questionId}`} Narritive={props.EDPNQuestion.narrativeText} EDPNAnswerObject={props.answerObject} Therapists={props.Therapists} EDPNQuestions={props.EDPNQuestions} answerObject={props.answerObject} setAnswerObject={props.setAnswerObject} />}
                </div>
            </>
            
        )
    }
    
};

